import React from 'react';
import {
  Dashboard as DashboardIcon,
  Business as BusinessIcon,
  Assignment as AssignmentIcon,
  Description as DescriptionIcon,
  People as PeopleIcon,
  Assessment as AssessmentIcon,
  History as HistoryIcon,
  Home as HomeIcon,
  HowToReg as HowToRegIcon,
  Tune as TuneIcon,
} from '@mui/icons-material';

/**
 * The sidebar for each role.
 *
 * Kept out of Layout so it can be tested: the sidebar is the only way into
 * some pages — nothing else links to Contract Management — and the admin menu
 * shipped without it, so admins had no way to see a contract at all.
 */
export const menuItemsFor = (role, { pendingRegistrationsCount = 0 } = {}) => {
  if (role === 'supplier') {
    return [
      { text: 'My Application', icon: <AssignmentIcon />, path: '/dashboard' },
      { text: 'New Application', icon: <BusinessIcon />, path: '/application/new' },
    ];
  }
  if (role === 'procurement') {
    return [
      { text: 'My tasks', icon: <HomeIcon />, path: '/dashboard' },
      { text: 'All tasks', icon: <AssignmentIcon />, path: '/tasks/all' },
      { text: 'Registrations', icon: <HowToRegIcon />, path: '/registrations', badge: pendingRegistrationsCount },
      { text: 'Supplier List', icon: <BusinessIcon />, path: '/suppliers' },
      { text: 'Reports', icon: <AssessmentIcon />, path: '/reports' },
      { text: 'Setups', icon: <TuneIcon />, path: '/setups' },
    ];
  }
  if (role === 'legal') {
    return [
      { text: 'Tasks', icon: <HomeIcon />, path: '/dashboard' },
      { text: 'Contract Management', icon: <DescriptionIcon />, path: '/contracts' },
      { text: 'Reports', icon: <AssessmentIcon />, path: '/reports' },
      { text: 'Setups', icon: <TuneIcon />, path: '/setups' },
    ];
  }
  if (role === 'super_admin') {
    return [
      { text: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard' },
      { text: 'Users', icon: <PeopleIcon />, path: '/users' },
      { text: 'Registrations', icon: <HowToRegIcon />, path: '/registrations', badge: pendingRegistrationsCount },
      { text: 'Suppliers', icon: <BusinessIcon />, path: '/suppliers' },
      { text: 'All Tasks', icon: <AssignmentIcon />, path: '/tasks/all' },
      { text: 'Contract Management', icon: <DescriptionIcon />, path: '/contracts' },
      { text: 'Audit Logs', icon: <HistoryIcon />, path: '/audit-logs' },
      { text: 'Reports', icon: <AssessmentIcon />, path: '/reports' },
      { text: 'Setups', icon: <TuneIcon />, path: '/setups' },
    ];
  }
  if (role === 'management') {
    return [
      { text: 'Contract Management', icon: <DescriptionIcon />, path: '/dashboard' },
      { text: 'All Tasks', icon: <AssignmentIcon />, path: '/tasks/all' },
      { text: 'Reports', icon: <AssessmentIcon />, path: '/reports' },
    ];
  }

  // Unreachable: User.role is an enum of exactly the five roles branched on
  // above. Kept as a minimal fallback rather than returning undefined, which
  // would throw on menuItems.map in Layout.
  return [{ text: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard' }];
};
